enum EBusinessRepresentativeCompany {
  HEADER = 'Генеральный директор',
  OTHER = 'Представитель компании',
}

export default EBusinessRepresentativeCompany;
